<template>
  <div>
    <div class="cen-title">
      <div>{{ $t("RAM.ALI.Cen.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:cen:update']"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:cen:export']"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="cen-top">
      <cloud-enterprise-network-search
        ref="search"
      ></cloud-enterprise-network-search>
    </div>
    <table-cloud-enterprise-network></table-cloud-enterprise-network>
  </div>
</template>

<script>
import CloudEnterpriseNetworkSearch from "../cen/CloudEnterpriseNetworkSearch";
import TableCloudEnterpriseNetwork from "../cen/TableCloudEnterpriseNetwork";

export default {
  name: "cen",
  components: {
    CloudEnterpriseNetworkSearch,
    TableCloudEnterpriseNetwork
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 304,
          accountType: 1
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportALiCen({
          companyId: this.companyId,
          accountName: this.accountName,
          resourceName: this.resourceName
        })
        .then(res => {
          let fileName = "cen.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.cen-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.cen-title > div:nth-child(1) {
  float: left;
}
.cen-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.cen-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/cen/Cen.vue